class SearchModal extends HTMLElement {
  constructor() {
    super();

    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener(
      'keyup',
      (event) => event.code && event.code.toUpperCase() === 'ESCAPE' && this.close()
    );
    this.summaryToggle.addEventListener(
      'click',
      this.onSummaryClick.bind(this)
    );
    const closeBtn = this.querySelector('button[type="button"]');
    const resetBtn = this.querySelector('button[type="reset"]');
    if (closeBtn) closeBtn.addEventListener('click', this.close.bind(this));
    if (resetBtn) resetBtn.addEventListener('click', this.reset.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open')
      ? this.close()
      : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close();
  }

  open() {
    setScrollbarWidth();
    setHeaderBottomPosition();

    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);

    this.detailsContainer.setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('search-modal--open');

    const input = this.detailsContainer.querySelector('input[type="search"]');
    const focusRoot = this.detailsContainer.querySelector('[tabindex="-1"]') || this.detailsContainer;

    trapFocus(focusRoot, input);

    // Drawer slide-in: refocus after paint so the caret is visible immediately
    const focusInput = () => {
      if (!input) return;
      try {
        input.focus({ preventScroll: true });
      } catch (e) {
        input.focus();
      }
    };
    requestAnimationFrame(() => {
      focusInput();
      setTimeout(focusInput, 80);
      setTimeout(focusInput, 220);
    });
  }

  close() {
    removeTrapFocus();
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('search-modal--open');
    const modal = this.querySelector('.search-modal');
    if (modal) modal.classList.remove('searching');
    document.dispatchEvent(new CustomEvent('searchmodal:close'));
  }

  reset(event) {
    event.preventDefault();
    const input = this.querySelector('input[type="search"]');
    if (input) input.value = '';
    const modal = this.querySelector('.search-modal');
    if (modal) modal.classList.remove('searching');
    if (input) input.focus({ preventScroll: true });
  }
}

customElements.define('search-modal', SearchModal);
